import { SvgLogo, SvgLogoProps } from './SvgLogo';

export const Twilio = ({ height, width, ...props }: SvgLogoProps) => (
  <SvgLogo
    data-test="Twilio"
    height={height}
    width={width}
    title="Twilio Logo"
    titleId="twilio-logo-title"
    viewBox="0 0 48 48"
    fill="none"
    {...props}
  >
    <path
      d="M24 0C10.72 0 0 10.72 0 24C0 37.28 10.72 48 24 48C37.28 48 48 37.28 48 24C48 10.72 37.28 0 24 0ZM24 41.6C14.24 41.6 6.4 33.76 6.4 24C6.4 14.24 14.24 6.4 24 6.4C33.76 6.4 41.6 14.24 41.6 24C41.6 33.76 33.76 41.6 24 41.6ZM34.88 18.08C34.88 20.8 32.64 23.04 29.92 23.04C27.2 23.04 24.96 20.8 24.96 18.08C24.96 15.36 27.2 13.12 29.92 13.12C32.64 13.12 34.88 15.36 34.88 18.08ZM34.88 29.92C34.88 32.64 32.64 34.88 29.92 34.88C27.2 34.88 24.96 32.64 24.96 29.92C24.96 27.2 27.2 24.96 29.92 24.96C32.64 24.96 34.88 27.2 34.88 29.92ZM23.04 29.92C23.04 32.64 20.8 34.88 18.08 34.88C15.36 34.88 13.12 32.64 13.12 29.92C13.12 27.2 15.36 24.96 18.08 24.96C20.8 24.96 23.04 27.2 23.04 29.92ZM23.04 18.08C23.04 20.8 20.8 23.04 18.08 23.04C15.36 23.04 13.12 20.8 13.12 18.08C13.12 15.36 15.36 13.12 18.08 13.12C20.8 13.12 23.04 15.36 23.04 18.08Z"
      fill="#F22F46"
    />
  </SvgLogo>
);
